import { Component, EventEmitter, Input, OnInit, Output, ViewChild, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { DropdownModule } from 'primeng/dropdown';
import { InputNumberModule } from 'primeng/inputnumber';
import { StepsModule } from 'primeng/steps';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { MessageService, MenuItem } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';

import { NGXLogger } from 'ngx-logger';
import { RichiesteService } from '../../../services/richieste.service';
import { Richiesta } from '../../../models/richiesta.model';
import { StiliService } from '../../../services/stili.service';
import { SchedeService } from '../../../services/schede.service';
import { Scheda } from '../../../models/scheda.model';
import { MappaSchedaNuovoInterventoComponent } from './mappa-scheda-nuovo-intervento.component';
import { InterventiService } from '../../../services/interventi.service';
import { TipoIntervento } from '../../../models/tipo-intervento.model';
import { Intervento } from '../../../models/intervento.model';

@Component({
  selector: 'app-nuovo-intervento',
  templateUrl: './nuovo-intervento.component.html',
  styleUrls: ['./nuovo-intervento.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    ButtonModule,
    InputTextModule,
    InputTextareaModule,
    DropdownModule,
    InputNumberModule,
    StepsModule,
    ToastModule,
    TooltipModule,
    MappaSchedaNuovoInterventoComponent
],
  providers: [DialogService, MessageService]
})
export class NuovoInterventoComponent implements OnInit {
  @Input() isEnteEsecutore: boolean = false;

  @ViewChild(MappaSchedaNuovoInterventoComponent) mappaSchedaNuovoInterventoComponent!: MappaSchedaNuovoInterventoComponent;
  @Output() interventoCreato = new EventEmitter<Intervento>();

  private fb = inject(FormBuilder);
  private schedaService = inject(SchedeService);
  private interventoService = inject(InterventiService);
  private richiesteService = inject(RichiesteService);
  private messageService = inject(MessageService);
  stiliService = inject(StiliService);
  private dialogService = inject(DialogService);

  form!: FormGroup;
  activeIndex = 0;
  visible = false;
  submitting = false;
  enteId: string | null = null;

  items: MenuItem[] = [
    { label: 'Seleziona la richiesta' },
    { label: 'Seleziona la scheda' },
    { label: 'Dettagli intervento' }
  ];

  richieste: Richiesta[] = [];
  comuni: any[] = [];
  schede: Scheda[] = [];
  tipiIntervento: TipoIntervento[] = [];
  statiIntervento: any[] = [];
  priorita = [
    { label: 'Alta', value: 1 },
    { label: 'Media', value: 2 },
    { label: 'Bassa', value: 3 },
  ];

  constructor(
    private logger: NGXLogger
  ) {
    this.initForm();
  }

  private initForm(): void {
    this.form = this.fb.group({
      richiesta: [null, Validators.required],
      scheda: [null, Validators.required],
      tipoIntervento: [null, Validators.required],
      priorita: [this.priorita[0], Validators.required],
      importoRichiesto: [null, [Validators.required, Validators.min(0)]],
      note: [null]
    });
  }

  show(): void {
    this.visible = true;
    this.enteId = localStorage.getItem("enteId") || '';
    if(this.isEnteEsecutore){
      this.logger.info('[NUOVO INTERVENTO] SONO UMVS!');
    }else{
      this.logger.info('[NUOVO INTERVENTO] SONO ENTE ESECUTORE! Ente ID: ' + this.enteId);
    }

    this.initForm();
    this.caricaRichieste();
    this.caricaSchede();
    this.caricaTipiIntervento();
  }

  hide(): void {
    this.visible = false;
    this.form.reset();
    this.activeIndex = 0;
  }

  goToPreviousStep(): void {
    if (this.activeIndex > 0) {
      this.activeIndex--;
    }
  }

  goToNextStep() {
    if (this.activeIndex === 0) {
      if (this.form.get('richiesta')?.value) {
        this.activeIndex++;
      }
    } else if (this.activeIndex === 1) {
      if (this.form.get('scheda')?.value) {
        this.activeIndex++;
      }
    } else if (this.activeIndex === 2) {
      this.salvaIntervento();
    }
  }

  ngOnInit(): void {
    // Preseleziona il primo elemento della lista
    if (this.richieste && this.richieste.length > 0) {
      this.form.get('richiesta')?.setValue(this.richieste[0]);
    }
  }

  caricaRichieste(): void {
    this.richiesteService.getRichiesteByEnte(this.enteId).subscribe({
      next: (data) => {
        this.logger.info('[NUOVO INTERVENTO] Richieste', data);

        // Filtra solo le richieste con stato "IN PREPARAZIONE"
        this.richieste = data.filter(richiesta =>
          richiesta.stato && richiesta.stato.descrizione === 'IN PREPARAZIONE'
        );

        // Preseleziona il primo elemento della lista
        if (this.richieste && this.richieste.length > 0) {
          this.form.get('richiesta')?.setValue(this.richieste[0]);
        }
      }
    });
  }

  caricaSchede(): void {
    if(this.isEnteEsecutore){
      this.schedaService.getSchedeEnteEsecutore().subscribe({
        next: (data) => {
          this.schede = data;
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Errore',
            detail: 'Errore nel caricamento delle schede'
          });
        }
      });
    }else{
      this.schedaService.getSchede().subscribe({
        next: (data) => {
          this.schede = data;
        }
      });
    }
  }
  caricaTipiIntervento(): void {
     this.interventoService.getTipiIntervento().subscribe({
      next: (data) => {
        this.tipiIntervento = data;
        this.logger.info('[NUOVO INTERVENTO] Tipi di intervento', this.tipiIntervento);
        // Preseleziona il primo elemento della lista
        if (this.tipiIntervento && this.tipiIntervento.length > 0) {
          this.form.get('tipoIntervento')?.setValue(this.tipiIntervento.find(t => t.codice === 'MO'));
        }
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Errore nel caricamento dei tipi di intervento'
        });
      }
    });
  }

  reset() {
    this.activeIndex = 0;
    this.form.reset();
    // Ripristina la preselezione della priorità ALTA dopo il reset
    this.form.get('priorita')?.setValue(this.priorita[0]);
  }

  salvaIntervento(): void {
    if (this.form.valid) {
      this.submitting = true;
      let nuovoIntervento = this.form.value as Intervento;
      nuovoIntervento.priorita = this.form.value.priorita.value;
      // Assicura che il campo note sia sempre presente, anche se vuoto (null anziché undefined)
      nuovoIntervento.note = this.form.value.note?.trim() || null;
      this.logger.info('[NUOVO INTERVENTO] Salva intervento', nuovoIntervento);
      this.interventoService.crea(nuovoIntervento).subscribe({
        next: () => {
          this.interventoCreato.emit(nuovoIntervento);
          this.reset();
          this.hide();
        },
        error: (error) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Errore',
            detail: 'Errore nella creazione dell\'intervento'
          });
        },
        complete: () => {
          this.submitting = false;
        }
      });
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Errore',
        detail: 'Compila tutti i campi obbligatori'
      });
    }
  }

  isStepValid(): boolean {
    switch (this.activeIndex) {
      case 0:
        return !!this.form.get('richiesta')?.value;
      case 1:
        return !!this.form.get('scheda')?.value;
      case 2:
        return this.form.valid;
      default:
        return false;
    }
  }

  async showMap(): Promise<void> {
    this.mappaSchedaNuovoInterventoComponent.show();
    this.mappaSchedaNuovoInterventoComponent.schedaSelezionataId.subscribe((id: any) => {
      this.form.patchValue({
        scheda: this.schede.find(s => s.id === id) as Scheda
      });
    });
  }
}
